import store from "../store";
function genarateFont(data) {
  let bodyStyles = document.body.style;

  if (data.font_size_detail) {
    const fontList = data.font_size_detail.filter(
      el => el.font_size_id == data.font_size
    );

    if (data.font_size == "2") {
      bodyStyles.setProperty("--text-xs", (fontList[0].value || "8") + "px");
      bodyStyles.setProperty("--text-sm", (fontList[1].value || "10") + "px");
      bodyStyles.setProperty("--text-md", (fontList[2].value || "12") + "px");
      bodyStyles.setProperty("--text-lg", (fontList[3].value || "14") + "px");
      bodyStyles.setProperty("--text-xl", (fontList[4].value || "16") + "px");
      bodyStyles.setProperty("--text-2xl", (fontList[5].value || "18") + "px");
      bodyStyles.setProperty("--text-3xl", (fontList[6].value || "22") + "px");
      bodyStyles.setProperty("--text-4xl", (fontList[7]?.value || "26") + "px");
    } else if (data.font_size == "3") {
      bodyStyles.setProperty("--text-xs", (fontList[0].value || "10") + "px");
      bodyStyles.setProperty("--text-sm", (fontList[1].value || "12") + "px");
      bodyStyles.setProperty("--text-md", (fontList[2].value || "14") + "px");
      bodyStyles.setProperty("--text-lg", (fontList[3].value || "16") + "px");
      bodyStyles.setProperty("--text-xl", (fontList[4].value || "18") + "px");
      bodyStyles.setProperty("--text-2xl", (fontList[5].value || "20") + "px");
      bodyStyles.setProperty("--text-3xl", (fontList[6].value || "24") + "px");
      bodyStyles.setProperty("--text-4xl", (fontList[7]?.value || "28") + "px");
    } else if (data.font_size == "1") {
      bodyStyles.setProperty("--text-xs", (fontList[0].value || "6") + "px");
      bodyStyles.setProperty("--text-sm", (fontList[1].value || "8") + "px");
      bodyStyles.setProperty("--text-md", (fontList[2].value || "10") + "px");
      bodyStyles.setProperty("--text-lg", (fontList[3].value || "13") + "px");
      bodyStyles.setProperty("--text-xl", (fontList[4].value || "14") + "px");
      bodyStyles.setProperty("--text-2xl", (fontList[5].value || "16") + "px");
      bodyStyles.setProperty("--text-3xl", (fontList[6].value || "20") + "px");
      bodyStyles.setProperty("--text-4xl", (fontList[7]?.value || "24") + "px");
    }
  }
  const fontBold = "/font/Kanit-SemiBold.ttf";
  const fontRegular = "/font/Kanit-Regular.ttf";
  // if (data.custom_font) {
  var newStyle = document.createElement("style");
  const fontFaceRule = `
        @font-face {
            font-family: 'CustomFont';
            src: url('${
              data.custom_font
                ? store.state.domain + data.custom_font.substring(1)
                : fontRegular
            }') format('truetype');
            font-weight: 400;
            font-display: swap;
        }
    `;

  const fontFaceRuleBold = `
        @font-face {
            font-family: 'CustomFont';
            src: url(${
              data.custom_font_bold
                ? store.state.domain + data.custom_font_bold.substring(1)
                : fontBold
            }) format('truetype');
            font-weight: 500;
            font-display: swap;
        }
            @font-face {
            font-family: 'CustomFont';
            src: url(${
              data.custom_font_bold
                ? store.state.domain + data.custom_font_bold.substring(1)
                : fontBold
            }) format('truetype');
            font-weight: 600;
            font-display: swap;
        }
    `;
  newStyle.appendChild(
    document.createTextNode(fontFaceRule + fontFaceRuleBold)
  );

  document.head.appendChild(newStyle);
}

export { genarateFont };
